import { unescape as n } from "./index91.mjs";
let e = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: n
};
const a = function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  e = {
    ...e,
    ...t
  };
}, r = () => e;
export {
  r as getDefaults,
  a as setDefaults
};
